import { useLayoutEffect, useState } from "react";
import api from "../../services/api";
import GeneralContext from "./GeneralContext";

// Mantem uma variável atualizada com as dimensões da tela
const useWindowSize = () => {
  const [size, setSize] = useState([window.innerWidth, window.innerHeight]);

  useLayoutEffect(() => {
    function updateSize() {
      setSize([window.innerWidth, window.innerHeight]);
    }

    window.addEventListener('resize', updateSize);
    updateSize();
    return () => window.removeEventListener('resize', updateSize);
  }, []);

  return size;
};

export default function GeneralContextProvider({ children }) {
  const [windowWidth, windowHeight] = useWindowSize();

  const maxWidthMobileMode = 700; // px
  const mobile_mode = windowWidth <= maxWidthMobileMode;

  const [loggedUser, setLoggedUser] = useState(null);
  const [show_loading, setShowLoading] = useState(false);

  function onChangeLoggedUser(user) {
    if (!user) {
      api.auth.removeAuthorizationToken();
      
      const redirectRoute = window.location.origin + '/login';
      window.location.href = redirectRoute;

      setTimeout(() => {
        setLoggedUser(null);
      }, 2000);

      return;
    }
    setLoggedUser(user);
  }

  return (
    <GeneralContext.Provider
      value={{
        loggedUser,
        setLoggedUser: onChangeLoggedUser,
        show_loading,
        setShowLoading,
        windowWidth,
        windowHeight,
        mobile_mode,
      }}
    >
      {children}
    </GeneralContext.Provider>
  );
}



